export default {
  club_name: 'Falun 2027',
  club_name_short: 'skiing',
  stadium_name: '',
  staging_url: 'https://skiing.api.fangroup.io',
  prod_url: 'https://skiing.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/skiing',
  club_logo: '/assets/teams/skiing.png',
  app_name: 'skiing',
  websale_name: 'skiing',
  ntb_team_id: 10065,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'skiing',
  monolithEnabled: false,
};
